import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UserAccessRightsGuard } from '../role/user-role/user-access-rights.guard'
import { AccessRights } from '../role/user-role/user-role'
import { CourseCreateComponent } from './create/show.component'
import { CourseGeneralTabComponent } from './general-tab/show.component'
import { CourseIndexComponent } from './index/index.component'
import { CourseShowComponent } from './show/show.component'
import { CourseParticipationTabComponent } from './participation-tab/show.component'
import { SaleCreateComponent } from '../sale/create/show.component'
import { CourseBookingTabComponent } from './course-booking-tab/show.component'
import { RouterHistoryLevelGuard } from 'src/app/shared/guards/router-history-level.guard'
import { CourseBookingCreateTabComponent } from './course-create-bookings-tab/show.component'
import { CourseCommunicationTabComponent } from './communication-tab/communication-tab.component'
import { CourseActivitiesMainTabComponent } from './course-activities-tab/course-activities-tab.component'
import { CourseAchievementTabComponent } from './course-achievement-tab/show.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CourseIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Course_read] }
  },
  {
    path: 'create',
    component: CourseCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Course_write] }
  },
  {
    path: ':courseId/create',
    component: CourseCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Course_write] }
  },
  {
    path: ':courseId/modal-course/general',
    outlet: 'modal',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseGeneralTabComponent
  },
  {
    path: ':courseId/modal-course/bookings',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseBookingTabComponent
  },
  {
    path: ':courseId/modal-course/bookings/create',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseBookingCreateTabComponent
  },
  {
    path: ':courseId/modal-course/communication',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseCommunicationTabComponent
  },
  {
    path: ':courseId/modal-course/achievement',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseAchievementTabComponent
  },
  {
    path: ':courseId/modal-course/activities',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseActivitiesMainTabComponent
  },
  {
    path: ':courseId/modal-course',
    outlet: 'modal',
    pathMatch: 'full',
    canActivate: [RouterHistoryLevelGuard],
    component: CourseParticipationTabComponent
  },
  {
    path: ':courseId',
    component: CourseShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Course_read] },
    children: [
      {
        path: '',
        component: CourseParticipationTabComponent,
        children: [
          {
            path: '',
            component: CourseParticipationTabComponent,
            pathMatch: 'full'
          },
          {
            path: 'sale',
            component: SaleCreateComponent,
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'general',
        component: CourseGeneralTabComponent,
        pathMatch: 'full'
      },
      {
        path: 'communication',
        component: CourseCommunicationTabComponent,
        pathMatch: 'full'
      },
      {
        path: 'activities',
        pathMatch: 'full',
        component: CourseActivitiesMainTabComponent
      },
      {
        path: 'bookings',
        component: CourseBookingTabComponent,
        pathMatch: 'full'
      },
      {
        path: 'achievement',
        component: CourseAchievementTabComponent,
        pathMatch: 'full'
      },
      {
        path: 'bookings/create',
        component: CourseBookingCreateTabComponent,
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseRoutingModule {}
